/* eslint-disable react/require-default-props */
import React, {
  useCallback, useEffect, useMemo, useState,
} from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import {
  Button, ButtonGroup, ButtonToolbar, Form,
} from 'react-bootstrap';
import classNames from 'classnames';
import { Link, useParams } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import slashEye from '../../../assets/img/icons/eye-slash.svg';
import eye from '../../../assets/img/icons/eye.svg';
import api from '../../../api/req';
import { debounce } from '../../../api/utils';

const PASSWORD_CHARS = '0123456789abcdefghijklmnopqrstuvwxyz_$!ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const PASSWORD_LENGTH = 8;

function PasswordResetForm({ hasLabel }) {
  // State
  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: '',
  });

  const [showMsg, setShowMsg] = useState({ msg: '', isSuccesss: false });
  const [showConfirmPass, setShowConfirmPass] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const { activateToken, uid } = useParams();
  window.localStorage.removeItem('refreshToken');
  window.localStorage.removeItem('accessToken');
  window.localStorage.removeItem('logica_data');

  const { ativationNewPassHandler } = useAuth();

  const onGeneratePassword = useCallback(
    () => {
      const newPassword = [...Array(PASSWORD_LENGTH)].reduce((R) => {
        const r = Math.floor(Math.random() * PASSWORD_CHARS.length);
        return R + PASSWORD_CHARS.substring(r, r + 1);
      }, '');
      setFormData({
        ...formData,
        password: newPassword,
        confirmPassword: newPassword,
      });
    },
    [formData],
  );

  const activationHandler = useCallback(() => {
    if (formData.password === formData.confirmPassword) {
      ativationNewPassHandler({
        uid,
        token: activateToken,
        new_password: formData.password,
        re_new_password: formData.password,
        setShowMsg,
      }).then(() => toast.success('Увійдіть за допомогою нового пароля', {
        theme: 'colored',
      }));
    } else {
      setShowMsg({ msg: 'Паролі не співпадають', isSuccesss: false });
    }
  }, [activateToken, ativationNewPassHandler, formData.confirmPassword, formData.password, uid]);

  // Handler
  const handleSubmit = (e) => {
    e.preventDefault();
    activationHandler();
  };

  const handleFieldChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const checkPassword = useCallback(
    async (passwd) => {
      const r = await api.post('/api/auth/check-password/', () => null, { password: passwd });
      if (r.status === 400) {
        const d = await r.json();
        setShowMsg({
          msg: d.password.join(', '),
          isSuccesss: false,
        });
      } else if (r.ok) {
        setShowMsg({
          msg: null,
          isSuccesss: true,
        });
      } else {
        throw new Error(`${r.status} ${r.statusText}`);
      }
    },
    [],
  );
  const checkPasswordDebounced = useMemo(
    () => debounce(checkPassword),
    [checkPassword],
  );
  useEffect(() => {
    if (formData.password) {
      checkPasswordDebounced(formData.password);
    }
  }, [checkPasswordDebounced, formData.password]);

  const submitAllowed = formData.password
    && formData.password === formData.confirmPassword && showMsg.isSuccesss;

  return (
    <>
      <Form
        className={classNames('mt-3', { 'text-left': hasLabel })}
        onSubmit={handleSubmit}
      >
        <Form.Group className="mb-3">
          {hasLabel && (
          <Form.Label>
            Новий пароль
          </Form.Label>
          )}
          <div style={{ display: 'flex' }}>
            <Form.Control
              placeholder={!hasLabel ? 'Новий пароль' : ''}
              value={formData.password}
              name="password"
              onChange={handleFieldChange}
              type={showPass ? 'text' : 'password'}
            />
            <Button
              variant="light"
              onClick={() => setShowPass(!showPass)}
            >
              <img
                src={showPass ? slashEye : eye}
                alt="Показати пароль"
              />
            </Button>
          </div>
          <Form.Text muted>
            {`Пароль має становити не менше 10 символів, має містити цифри,
            великі або малі букви або знак підкреслення "_"`}
          </Form.Text>
        </Form.Group>

        <Form.Group className="mb-3">
          {hasLabel && <Form.Label>Підтвердьте пароль</Form.Label>}
          <div style={{ display: 'flex' }}>
            <Form.Control
              placeholder={!hasLabel ? 'Підтвердьте пароль' : ''}
              value={formData.confirmPassword}
              name="confirmPassword"
              onChange={handleFieldChange}
              type={showConfirmPass ? 'text' : 'password'}
            />
            <Button
              variant="light"
              onClick={() => setShowConfirmPass(!showConfirmPass)}
            >
              <img
                src={showPass ? slashEye : eye}
                alt="Показати пароль"
              />
            </Button>
          </div>
        </Form.Group>
        <ButtonToolbar aria-label="Toolbar with button groups">
          <ButtonGroup className="me-2 mb-1" aria-label="First group">
            <Button
              onClick={onGeneratePassword}
              className="w-100"
              size="sm"
            >
              Згенерувати
            </Button>
          </ButtonGroup>
          <ButtonGroup className="me-2 mb-1" aria-label="First group">
            <Button
              type="submit"
              className="w-100"
              size="sm"
              disabled={!submitAllowed}
            >
              Встановити пароль
            </Button>
          </ButtonGroup>
        </ButtonToolbar>
      </Form>
      <div className={showMsg.isSuccess ? 'text-success' : 'text-danger'}>
        {showMsg.msg}
        {formData.password !== formData.confirmPassword && (
        <p>Паролі не співпадають</p>
        )}
      </div>
      {showMsg.isSuccess && (showMsg.msg != null) && (
      <div>
        <Link
          to="/"
        >
          Натисніть тут для початку роботи dв системі `&quot;Є-Пічник`&quot;
        </Link>
      </div>
      )}
    </>
  );
}

PasswordResetForm.propTypes = {
  hasLabel: PropTypes.bool,
  paramsUrl: PropTypes.shape({
    activateToken: '',
    uid: '',
  }),
};

export default PasswordResetForm;
